module.exports = __webpack_public_path__ + "img/expenditure.95e2bc17.svg";